export enum ThreatPolicyAction {
  ALLOW_DOMAIN = "allow_network_domain",
  BLOCK_DOMAIN = "block_network_domain",
  ALLOW_IP = "allow_network_ip",
  BLOCK_IP = "block_network_ip",
  ALLOW_PORT = "allow_network_port",
  BLOCK_PORT = "block_network_port",
}

export enum ControlDirection {
  INBOUND = "inbound",
  OUTBOUND = "outbound",
}
